import { Image } from "../Image/Image";

export const PopupSideBarImage = ({src, alt, ...props}) => {
    return <Image src={src + "?width=537&height=358&rmode=max"} alt={alt} />
}